<template>
    <div class='summary-container'>
        <Placeholder class='title-placeholder'/>
        <Placeholder class='price-placeholder'/>
        <Placeholder class='product-code-placeholder'/>
        <Placeholder class='reviews-placeholder'/>
    </div>
</template>

<script>
import Placeholder from '@/ecom/components/loading/Placeholder.vue';

export default {
    components: {Placeholder}    
}
</script>

<style lang="scss" scoped>
.title-placeholder{
    width: 100%; 
    height: 35px;
}

.price-placeholder{
    width: 20%; 
    height: 30px;
}

.product-code-placeholder{
    width: 40%; 
    height: 25px;
}

.reviews-placeholder{
    width: 40%; 
    height: 25px;
}

</style>